module.exports = __webpack_public_path__ + "static/quotemark-blk-92f614de5d36fc30eea4eda725860356.gif";